// extracted by mini-css-extract-plugin
export default {"hgroup":"Top_hgroup__WgoR0","main":"Top_main__XgIIG","inner":"Top_inner__xibyb"};